import { render, staticRenderFns } from "./RecebimentoDeNotaFiscalImportXmlView.vue?vue&type=template&id=16f5294a"
import script from "./RecebimentoDeNotaFiscalImportXmlView.vue?vue&type=script&lang=js"
export * from "./RecebimentoDeNotaFiscalImportXmlView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports